module.exports = __webpack_public_path__ + "11b8f649b495c4c38221da586475a8e6.svg";